import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
//import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';
import {Observable} from 'rxjs/Rx';


import {AppSettings} from '../app-settings';

import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class TripService {

  public token: string;
  header1 = new Headers({'Accept': 'application/json'});//'Content-Type':'multipart/form-data'},
  option1 = new RequestOptions({headers: this.header1});

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  getDashBoard(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/trip-dash-board", params, this.options).map(response => response.json());
  }

  registrationMonths(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/registration-months", params, this.options).map(response => response.json());
  }

  signUps(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/event/trip-sign-ups", params, this.options).map(response => response.json());
  }

  getEventsInfo(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/event-info", params, this.options).map(response => response.json().events);
  }

  getTripAttendeeList(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/trip-attendee/list", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  getTriperDetail(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-trip-detail', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  fullCancel(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/trip-full-cancel", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  tripAttendeeCancel(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/trip-attendee-cancel", params, this.options).map(this.extractData)
        .catch(this.handleError);
  }

  addAttendee(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT + "/public/api/v1/admin/trip-add-attendee", params, this.options).map(response => response.json());
  }

  getAttendeeInfo(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-trip-attendee-info', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }


  getAttendeeDetail(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/trip-attendee-detail', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  updateTripAttendee(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/update-trip-attendee', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  updateTripTravelInfo(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/update-trip-travel-info", params, this.options).map(response => response.json());
  }

  updateHotelCheckInOut(params): Observable<any> {
    return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/admin/update-hotel-check-in-out", params, this.options).map(response => response.json());
  }

  getTripActivityInfo(params): Observable<any>{
    return this.authHttp.post(AppSettings.API_STARTPOINT + '/public/api/v1/admin/get-trip-activity-info', params, this.options)
        .map(this.extractData)
        .catch(this.handleError);
  }



  private extractData(res: Response) {
    let body = res.json();
    //console.log(body);
    return body || [];
  }

  private handleError(error: Response | any) {
    return Observable.throw(<any>error);
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/trip.service.ts